export default "__VITE_ASSET__DADDGF4e__"